import React, { useEffect, useState } from 'react';
import { TopNavigation } from "@cloudscape-design/components";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { Navigate, useNavigate } from 'react-router-dom';


function AppHeader() {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [userEmail, setUserEmail] = useState("")
  
  const navigate = useNavigate();

  const handleUtilityClick = (event: any) => {
    if (event.detail.id === 'signout') {
      signOut(); // Trigger the sign-out action
      navigate('/');
    }
  }

  const printUserAttributes = async () => {
    try {
      const userAttributes = await fetchUserAttributes();
      const email = userAttributes.email || ""; // Provide a default value if undefined
      // console.log('Email:', userAttributes);
      setUserEmail(email); // Safely set the user email
    } catch (e) {
      // console.log("Cannot fetch user attributes", e);
    }
  };

 useEffect(()=> {
  printUserAttributes()
 })
  
  

  return (
    <TopNavigation
      identity={{
        href: "/",
        title: "Mining Suite",
        logo: {
          src: "logo512.png",
          alt: "Application",
        },
      }}
      utilities={[
        {
          type: "button",
          text: "Link",
          href: "https://cloudscape.design/",
          external: true,
          externalIconAriaLabel: "(opens in a new tab)",
        },
        {
          type: "button",
          iconName: "notification",
          title: "Notifications",
          ariaLabel: "Notifications (unread)",
          badge: true,
          disableUtilityCollapse: false,
        },
        {
          type: "menu-dropdown",
          iconName: "settings",
          ariaLabel: "Settings",
          title: "Settings",
          items: [
            {
              id: "settings-org",
              text: "Organizational settings",
            },
            {
              id: "settings-project",
              text: "Project settings",
            },
          ],
        },
        {
          type: "menu-dropdown",
          text: user?.username || "User",
           description: userEmail ,
        
          iconName: "user-profile",
          items: [
            { id: "profile", text: "Profile" , href: "/admin/users/897563"},
            { id: "preferences", text: "Preferences" },
            { id: "security", text: "Security" },
            {
              id: "support-group",
              text: "Support",
              items: [
                {
                  id: "documentation",
                  text: "Documentation",
                  href: "#",
                  external: true,
                  externalIconAriaLabel: " (opens in new tab)",
                },
                { id: "support", text: "Support" },
                {
                  id: "feedback",
                  text: "Feedback",
                  href: "#",
                  external: true,
                  externalIconAriaLabel: " (opens in new tab)",
                },
              ],
            },
            { id: "signout", text: "Sign out" },
          ],
          onItemClick: handleUtilityClick,
        },
      ]}
    />
  );
}

export default AppHeader;
